import React from "react";
import { useLanguage } from "../../Language";
import { HostSystemItemView } from "@tlc/ls2pac/dto/HostSystemItemView";
import PrintDialog from "./PrintDialog";

interface AccountPrintLoanHistoryDialogProps {
  loanHistory: HostSystemItemView[];
  startDate: string;
  endDate: string;
  open: boolean;
  onClose: () => void;
}

export default function AccountPrintLoanHistoryDialog({
  loanHistory,
  startDate,
  endDate,
  open,
  onClose,
}: AccountPrintLoanHistoryDialogProps) {
  const { translate } = useLanguage();

  const buildHtml = () => {
    const isSerial = loanHistory.some(
      (item) =>
        (item.enumeration && item.enumeration.length > 0) ||
        (item.chronology && item.chronology.length > 0),
    );
    const colSpan = isSerial ? 5 : 3;

    return `
      <div>
        <h2 align="center" style="text-transform: capitalize;">
          ${translate("exportData_loanHistory")}: ${startDate} - ${endDate}
        </h2>
        <table width="100%" cellpadding="5">
          <thead>
            <tr>
              <th wrap="nowrap"></th>
              <th wrap="nowrap">${translate("exportData_titleAuthor")}</th>
              ${
                isSerial
                  ? `
                <th wrap="nowrap">${translate("exportData_chronology")}</th>
                <th wrap="nowrap">${translate("exportData_numbering")}</th>
              `
                  : ""
              }
              <th wrap="nowrap">${translate("exportData_loanDate")}</th>
            </tr>
          </thead>
          <tbody>
          ${
            loanHistory.length > 0
              ? loanHistory
                  .map(
                    (item, index) => `
                  <tr>
                    <td align="left" valign="top">${index + 1}.</td>
                    <td align="left" valign="top">${item.title ?? ""}<br>${item.author ?? ""}</td>
                    ${
                      isSerial
                        ? `
                      <td align="left" valign="top">${item.chronology ?? ""}</td>
                      <td align="left" valign="top">${item.enumeration ?? ""}</td>
                      `
                        : ""
                    }
                    <td align="left" valign="top">${item.outDateString ?? ""}</td>
                  </tr>
                `,
                  )
                  .join("")
              : `<tr><td colspan="${colSpan}">${translate("noLoanHistoryInRange",)}</td></tr>`
          }
          </tbody>
        </table>
      </div>
      <br class="pagebreak">
    `;
  };

  return (
    <PrintDialog
      dialogTitle={translate("exportData_loanHistory")}
      htmlContent={buildHtml()}
      open={open}
      onClose={onClose}
    />
  );
}
